import type { Depot } from '@dpdgroupuk/fmx-ui/types';
import { joinStringsWithComma } from '@dpdgroupuk/fmx-ui/utils/string';

export const getDepotAddressString = (depot: Depot): string => {
  const { depotName, town, street, postcode } = depot;
  return joinStringsWithComma([depotName, town, street, postcode]);
};
